export default function StepSubTitle({ children }) {
    return <div className={'text-center text-base mb-1'}>{children}</div>
}